export default __webpack_public_path__ + "static/media/change-pw.21092558.svg";